import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getRemoteConfig, getValue } from 'firebase/remote-config';
// import { getValue } from 'firebase/remote-config';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

console.log(firebaseConfig);

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const appSettings = {
  appName: 'Lumen'
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const remoteConfig = getRemoteConfig(app);
console.log(remoteConfig);
remoteConfig.settings.minimumFetchIntervalMillis = 60000; //3600000;

remoteConfig.defaultConfig = {
  'enable_feedback_alert': false,
  'enable_iotec_wallet_payment_method': false,
  'enable_consent_and_verification_card': false,
  'max_credits_top_up': 100000,
  'enable_new_credit_checks_layout': false,
  'feedback_survey_code': 'customer_feedback_001',
  'feedback_survey_url': 'www.iotec.io',
  'feedback_survey_title': 'We value your feedback',
  'feedback_survey_message': 'Please take a moment to share your experience using our app. It won\'t take more than 5 minutes. Your insights will help us improve our services.',
};

export const remoteConfigData = {
  enableFeedbackAlert: () => {
    return getValue(remoteConfig, 'enable_feedback_alert').asBoolean();
  },
  enableIotecWalletPaymentMethod: () => {
    return getValue(remoteConfig, 'enable_iotec_wallet_payment_method').asBoolean();
  },
  enableConsentVerificationCard: () => {
    return getValue(remoteConfig, 'enable_consent_and_verification_card').asBoolean();
  },

  newCreditChecksLayout: () => {
    return getValue(remoteConfig, 'enable_new_credit_checks_layout').asBoolean();
  },
  maxCreditsTopUp: () => {
    return getValue(remoteConfig, 'max_credits_top_up').asNumber();
  },
  feedbackSurveyCode: () => {
    return getValue(remoteConfig, 'feedback_survey_code').asString();
  },
  feedbackSurveyUrl: () => {
    return getValue(remoteConfig, 'feedback_survey_url').asString();
  },
  feedbackSurveyTitle: () => {
    return getValue(remoteConfig, 'feedback_survey_title').asString();
  },
  feedbackSurveyMessage: () => {
    return getValue(remoteConfig, 'feedback_survey_message').asString();
  },
};

